export function ajax(route, payload = {}, options){
    if( !route ) return;

    let data = {
        action: 'ff_custom_ajax',
        nonce: site_data.nonce,
        route,
    }

    jQuery.ajax({
        url: site_data.ajax_url,
        type: "post",
        data: {...data, ...payload},
        dataType : "json",
    })
    .done(function(res){
        if( typeof options.done === 'function' ) {
            options.done(res);
        }
    })
    .always(function(res){
        if( typeof options.always === 'function' ) {
            options.always(res);
        }
    })
}